var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:_vm.cssClasses,attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.click}},[_c('span',{staticClass:"pf-c-button__icon pf-m-start",attrs:{"v-if":_vm.icon}},[_c('i',{class:['fas', _vm.icon],attrs:{"aria-hidden":"true"}})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }